export default function needsAuth(url?: string): boolean {
  if (!url || typeof url !== "string") return false;
  const base = process.env.VUE_APP_GENESIS_API_URL;
  if (!base) return false;
  // normalize both strings to avoid trailing slashes issues
  try {
    return url.includes(base);
  } catch {
    return false;
  }
}
